import type Pageable from 'models/Pageable';
import type {
  DealerAgreementRepaidAmountVO,
  DealerAgreementRepaidAmountVOModel,
} from 'models/vo/DealerAgreementRepaidAmountVO';
import { formattingToDealerAgreementRepaidAmountVOModel } from 'models/vo/DealerAgreementRepaidAmountVO';
import http from 'utils/http';
import API_FI from 'utils/http/api/financier';

import type { FinancierDealerAgreementRepaidAmountsListRequest } from './requests';

export async function requestFinancierDealerAgreementRepaidAmountsList(
  pageNumber: number,
  rowCount: number,
  searchValue: FinancierDealerAgreementRepaidAmountsListRequest,
): Promise<Pageable<DealerAgreementRepaidAmountVOModel[]>> {
  const response = await http.get<Pageable<DealerAgreementRepaidAmountVO[]>>({
    url: API_FI.DEALER_AGREEMENT_REPAID_AMOUNTS.DEALER_AGREEMENT_REPAID_AMOUNT_LIST,
    data: {
      pageNumber,
      rowCount,
      ...searchValue,
    },
  });

  return {
    ...response,
    content: response.content.map(item => formattingToDealerAgreementRepaidAmountVOModel(item)),
  };
}
